(() => {
  const updateCartCount = (count) => {
    document.querySelectorAll('.header__cart-count, .flashark-header__cart-count').forEach((node) => { node.textContent = count; });
    if (window.theme) window.theme.cartCount = count;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-flashark-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');
    const original = button.querySelector('[data-add-label]');
    const originalText = original && original.textContent;
    if (original) original.textContent = 'Adding…';
    try {
      const response = await fetch(window.routes ? window.routes.cartAddUrl : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.flasharkAddToCart), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add product');
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((result) => result.json());
      updateCartCount(cart.item_count);
      // This homepage card uses its own Ajax request. Use the Flashark cart
      // event rather than the theme-wide product:added event, which is also
      // handled by the legacy cart controller and can cause a second render.
      document.dispatchEvent(new CustomEvent('flashark:cart-updated', {
        bubbles: true,
        detail: {
          button,
          quantity: 1,
          variant: { id: Number(button.dataset.flasharkAddToCart) }
        }
      }));
      if (original) original.textContent = 'Added';
      window.setTimeout(() => { if (original) original.textContent = originalText; }, 1300);
    } catch (error) {
      if (original) original.textContent = 'Try again';
      window.setTimeout(() => { if (original) original.textContent = originalText; }, 1600);
    } finally {
      window.setTimeout(() => { button.disabled = false; button.classList.remove('is-loading'); }, 350);
    }
  });
})();
